import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from './confirmation-popup/confirmation-popup.component';
import { IConfirmationPopupComponentData, IConfirmationPopupComponentResult } from './confirmation-popup/interfaces';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  constructor(private matDialog: MatDialog) {
  }

  async showPopup<TComponent, TComponentData, TComponentResult>(
    component: ComponentType<TComponent>, componentData: TComponentData
  ): Promise<TComponentResult | undefined> {
    const promise = new Promise<TComponentResult | undefined>(resolve => {
      this.matDialog.open(component, { data: componentData }).afterClosed().subscribe({
        next: result => resolve(result)
      });
    });
    return promise;
  }

  async showConfirmation(componentData: IConfirmationPopupComponentData): Promise<IConfirmationPopupComponentResult | undefined> {
    const promise = new Promise<IConfirmationPopupComponentResult | undefined>(resolve => {
      this.matDialog.open<ConfirmationPopupComponent, IConfirmationPopupComponentData, IConfirmationPopupComponentResult>(
        ConfirmationPopupComponent, { data: componentData }
      ).afterClosed().subscribe({
        next: result => resolve(result)
      });
    });
    return promise;
  }
}
